import type { IViewDataInitialState } from 'src/redux/viewData/types';

const SECTION_KEY = 'ACR_SECTIONS_DETAIL';

interface SubtitleAction {
  value: string;
}

export const setSubtitle = (
  state: IViewDataInitialState,
  action: SubtitleAction,
): IViewDataInitialState => ({
  ...state,
  [SECTION_KEY]: {
    ...state[SECTION_KEY],
    isFetchingSubtitle: true,
    data: {
      ...state[SECTION_KEY].data,
      custom_subtitle: action.value,
    },
  },
});

export const setSubtitleSuccess = (
  state: IViewDataInitialState,
  action: SubtitleAction,
): IViewDataInitialState => ({
  ...state,
  [SECTION_KEY]: {
    ...state[SECTION_KEY],
    isFetchingSubtitle: false,
    data: {
      ...state[SECTION_KEY].data,
      custom_subtitle: action.value,
    },
  },
});
